function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import throttle from 'lodash-es/throttle';
import { sdkLogger } from '../../logger';
import { checkIsManifestLinearType } from '../../utils/playback-type';
import { waitForEvent } from '../../utils/wait-for-event';
import { MINIMUM_VERSION_FOR_UPDATE_START_TIME, isVersionCompliant } from './shaka-version-utils';
import { SimpleTimer } from '../../utils/simple-timer';
export var MINIMUM_SEEK_BANDWIDTH = 500000;
export var POST_SEEK_FIX_INTERVAL = 200;
export var MAX_LIVE_DRIFT = 1;
// value from 0-1 representing max relative distance from the live edge
export var SAFE_LIVE_DRIFT_RESET = 0;
// value from 0-1 representing the safe relative distance from the live edge
export var SHAKA_SEEK_THROTTLE_MS = 900;
/** Timeout to re-trigger seek if no buffered content appears after a seek. */ export var SEEK_STALL_TIMEOUT = 3000;
// Only allows firing one seek in a set amount of time
// Pauses player when seeking and resumes after seek completes
// Selects a low bandwidth track and disables ABR, then reenables after seek
// Plays and pauses video to ensure seeks are still responsive and occur
// Plays and pauses to escape unwanted state of paused by content is playing
// Makes sure we don't fall out the live window when loads take a very long time
// Retry seek when 'seeking' event never transitions to 'seeked'
/**
 * Implements various tweaks and safeguards to shaka's seeking behaviour
 */ export var ShakaPlayerEngineSeeker = /*#__PURE__*/ function() {
    "use strict";
    function ShakaPlayerEngineSeeker(playbackType, player, videoElement, config) {
        var _this = this;
        _class_call_check(this, ShakaPlayerEngineSeeker);
        _define_property(this, "playbackType", void 0);
        _define_property(this, "player", void 0);
        _define_property(this, "videoElement", void 0);
        _define_property(this, "config", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "seekStallTimer", void 0);
        _define_property(this, "postSeekFixInterval", void 0);
        _define_property(this, "wasPlayingBeforeSeek", void 0);
        _define_property(this, "latestSafePosition", void 0);
        _define_property(this, "presentationStartDate", void 0);
        _define_property(this, "isPausing", void 0);
        _define_property(this, "throttledSeek", void 0);
        _define_property(this, "nativeVideoElementSeeked", void 0);
        this.playbackType = playbackType;
        this.player = player;
        this.videoElement = videoElement;
        this.config = config;
        this.logger = sdkLogger.withContext('Shaka PEI Seeker');
        this.postSeekFixInterval = null;
        this.isPausing = false;
        this.nativeVideoElementSeeked = function() {
            if (_this.config.seekingStallRetryEnabled) {
                _this.seekStallTimer.stop();
                _this.videoElement.removeEventListener('seeked', _this.nativeVideoElementSeeked);
            }
        };
        this.throttledSeek = throttle(this.doSeekAsynchronously, SHAKA_SEEK_THROTTLE_MS);
        this.seekStallTimer = new SimpleTimer();
    }
    _create_class(ShakaPlayerEngineSeeker, [
        {
            key: "seek",
            value: function seek(position) {
                var safePosition = this.config.safeSeek ? this.ensureSafeSeek(position) : position;
                // Mitigates buffering timeout when seeking in quick succession on playready
                // See: https://github.com/NBCUDTC/core-video-sdk-js/pull/2948
                if (this.config.throttleSeeking) {
                    this.throttledSeek(safePosition);
                } else {
                    this.doSeekAsynchronously(safePosition);
                }
                return safePosition;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.throttledSeek.cancel();
                clearInterval(this.postSeekFixInterval);
                this.seekStallTimer.destroy();
                this.videoElement.removeEventListener('seeked', this.nativeVideoElementSeeked);
            }
        },
        {
            key: "handleSeeked",
            value: function handleSeeked() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_player_getConfiguration_abr, _this_player_getConfiguration;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.config.lowerBandwidthOnSeek && !((_this_player_getConfiguration = _this.player.getConfiguration()) === null || _this_player_getConfiguration === void 0 ? void 0 : (_this_player_getConfiguration_abr = _this_player_getConfiguration.abr) === null || _this_player_getConfiguration_abr === void 0 ? void 0 : _this_player_getConfiguration_abr.enabled)) {
                                    _this.player.configure({
                                        abr: {
                                            enabled: true
                                        }
                                    });
                                }
                                if (_this.config.togglePlayPauseAfterSeek) {
                                    clearInterval(_this.postSeekFixInterval);
                                    _this.postSeekFixInterval = null;
                                }
                                if (!(_this.config.pauseOnSeek && _this.wasPlayingBeforeSeek)) return [
                                    3,
                                    2
                                ];
                                _this.wasPlayingBeforeSeek = false;
                                return [
                                    4,
                                    _this.doPlayAndWaitForComplete()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getLiveWindow",
            value: function getLiveWindow() {
                var _this_player_seekRange = this.player.seekRange(), start = _this_player_seekRange.start, end = _this_player_seekRange.end;
                // Note: Guard against browser engines that allow currentTime to exceed seekable range (e.g. Safari)
                var adjustedEnd = Math.max(this.videoElement.currentTime, end);
                return {
                    start: start,
                    end: adjustedEnd,
                    startDate: checkIsManifestLinearType(this.playbackType) ? this.getDateForLiveWindowPosition(start) : undefined
                };
            }
        },
        {
            key: "setPresentationStartDate",
            value: function setPresentationStartDate(date) {
                this.presentationStartDate = date;
            }
        },
        {
            key: "getDateForLiveWindowPosition",
            value: function getDateForLiveWindowPosition(windowStartSec) {
                if (!this.presentationStartDate) {
                    var _this_player_getOriginalPresentationStartTimeAsDate, _this_player;
                    var _this_player_getOriginalPresentationStartTimeAsDate1;
                    // The start date can change over time in shaka due to clock offset corrections
                    // In order to provide consistent date => content time conversions, just keep the initial start time
                    this.presentationStartDate = (_this_player_getOriginalPresentationStartTimeAsDate1 = (_this_player_getOriginalPresentationStartTimeAsDate = (_this_player = this.player).getOriginalPresentationStartTimeAsDate) === null || _this_player_getOriginalPresentationStartTimeAsDate === void 0 ? void 0 : _this_player_getOriginalPresentationStartTimeAsDate.call(_this_player)) !== null && _this_player_getOriginalPresentationStartTimeAsDate1 !== void 0 ? _this_player_getOriginalPresentationStartTimeAsDate1 : this.player.getPresentationStartTimeAsDate();
                }
                var startDate = undefined;
                if (this.presentationStartDate) {
                    startDate = new Date(this.presentationStartDate);
                }
                if (startDate) {
                    var startDateStr = startDate.toISOString();
                    startDate.setTime(startDate.getTime() + windowStartSec * 1000);
                    this.logger.verbose("Start Date:".concat(startDate.toISOString(), " Window Start: ").concat(startDateStr));
                    return startDate;
                } else {
                    return undefined;
                }
            }
        },
        {
            key: "doPauseAndWaitForComplete",
            value: /**
     * Pauses playback and then waits for pause event to fire before returning.
     * Sets isPausing to indicate if we are currently waiting.
     */ function doPauseAndWaitForComplete() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.isPausing = true;
                                _this.videoElement.pause();
                                // @ts-ignore
                                return [
                                    4,
                                    waitForEvent(_this.videoElement, 'pause')
                                ];
                            case 1:
                                _state.sent();
                                _this.isPausing = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doPlayAndWaitForComplete",
            value: /**
     * Starts playback and then waits for playing event to fire before returning
     */ function doPlayAndWaitForComplete() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.videoElement.play();
                                // @ts-ignore
                                return [
                                    4,
                                    waitForEvent(_this.videoElement, 'playing')
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "doSeekAsynchronously",
            value: function doSeekAsynchronously(safePosition) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_videoElement, useUpdateStartTime, targetTime;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!// Seekability workaround. Live seeks occur after a suspended timeline item is resumed.
                                // We have found that this can leave the video element unresponsive to seek instructions.
                                // The below helps it recover.
                                // TODO: Investigate if the waits are necessary
                                (_this.config.togglePlayPauseBeforeSeek && _this.videoElement.paused)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.playAndPause()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // On some lower spec devices it seems that odd things happen if multiple quick seeks are performed
                                // multiple seeks can get in here and both be waiting for the pause to finish
                                // which causes some strange delays and locking up (probably an event emit quirk with shaka)
                                // If we are already waiting for a pause to happen, save the desired position and return
                                // Once the pause happens, the latest position will be used
                                _this.latestSafePosition = safePosition;
                                if (_this.isPausing) {
                                    // @ts-ignore
                                    return [
                                        2
                                    ];
                                }
                                _this.wasPlayingBeforeSeek = !_this.videoElement.paused || _this.wasPlayingBeforeSeek;
                                if (!(_this.config.pauseOnSeek && !_this.videoElement.paused)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.doPauseAndWaitForComplete()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                useUpdateStartTime = ((_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.readyState) === 0 && isVersionCompliant(shaka.Player.version, MINIMUM_VERSION_FOR_UPDATE_START_TIME);
                                if (useUpdateStartTime) {
                                    // Required during video startup to prevent seek loop bug
                                    // Shaka is otherwise unaware we are no longer at position 0
                                    _this.player.updateStartTime(_this.latestSafePosition);
                                } else {
                                    _this.videoElement.currentTime = _this.latestSafePosition;
                                }
                                // Guard against stalls due to loss in precision by rounding up to nearest thousandth.
                                // Video element current time should always be >= target time.
                                // Reference: https://github.com/shaka-project/shaka-player/issues/2831
                                if (!useUpdateStartTime && _this.videoElement.currentTime < _this.latestSafePosition) {
                                    _this.latestSafePosition = Math.ceil(_this.latestSafePosition * 1e3) / 1e3;
                                    _this.videoElement.currentTime = _this.latestSafePosition;
                                }
                                if (_this.config.seekingStallRetryEnabled) {
                                    _this.seekStallTimer.stop();
                                    targetTime = _this.videoElement.currentTime;
                                    _this.videoElement.addEventListener('seeked', _this.nativeVideoElementSeeked);
                                    _this.seekStallTimer.start({
                                        callback: function() {
                                            _this.videoElement.removeEventListener('seeked', _this.nativeVideoElementSeeked);
                                            if (_this.videoElement.buffered.length === 0 && targetTime === _this.videoElement.currentTime) {
                                                _this.videoElement.currentTime = targetTime;
                                                _this.logger.info("Seeking stall detected, retrying at time: ".concat(targetTime));
                                            }
                                        },
                                        timeMs: SEEK_STALL_TIMEOUT
                                    });
                                }
                                if (_this.config.lowerBandwidthOnSeek) {
                                    _this.selectLowBandwidthTrack();
                                }
                                if (_this.config.togglePlayPauseAfterSeek) {
                                    _this.setPostSeekFixInterval();
                                }
                                return [
                                    2,
                                    safePosition
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "ensureSafeSeek",
            value: function ensureSafeSeek(position) {
                // The below logic exists to ensure that, when using dual player, resuming the main content after ads will continue from a safe position.
                // As dual player is used on lower performance devices (old WebOS), the switch from ads to main content can be very slow.
                // This means that an originally safe position may no longer be safe by the time we get to this point.
                // Currently linear scrubbing is not supported for old WebOS, so this should be the only reason we use this logic.
                var _this_getLiveWindow = this.getLiveWindow(), start = _this_getLiveWindow.start, end = _this_getLiveWindow.end;
                var bufferSize = end - start;
                var drift = (end - position) / bufferSize;
                var safePosition = end - bufferSize * SAFE_LIVE_DRIFT_RESET;
                var correctedPosition = position;
                if (drift > MAX_LIVE_DRIFT && safePosition > position) {
                    correctedPosition = safePosition;
                    this.logger.info('Live position drift is unsafe, seeking back to safe zone');
                }
                return Math.min(end, correctedPosition);
            }
        },
        {
            key: "playAndPause",
            value: /**
     * Plays the video element, then waits for playing event. Then pauses and waits for pausing event.
     */ function playAndPause() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.doPlayAndWaitForComplete()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.doPauseAndWaitForComplete()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "selectLowBandwidthTrack",
            value: /**
     * Finds the lowest bandwidth track that's above the minimum required bandwidth (and is the correct language).
     * Disables Shaka's ABR and then selects the track.
     */ function selectLowBandwidthTrack() {
                var tracks = this.player.getVariantTracks();
                var currentTrack = tracks.find(function(x) {
                    return x.active;
                });
                if (currentTrack) {
                    tracks.sort(function(a, b) {
                        return a.bandwidth - b.bandwidth;
                    });
                    var loweredBandwidthTrack = tracks.find(function(x) {
                        return x.active || x.bandwidth >= MINIMUM_SEEK_BANDWIDTH && x.originalLanguage === currentTrack.originalLanguage;
                    });
                    this.logger.info("seek track bandwidth: ".concat(loweredBandwidthTrack.bandwidth));
                    this.player.configure({
                        abr: {
                            enabled: false
                        }
                    });
                    this.player.selectVariantTrack(loweredBandwidthTrack, true);
                }
            }
        },
        {
            key: "setPostSeekFixInterval",
            value: /**
     * Sets an interval which will play and then pause to escape an unwanted state
     *  of paused and rebuffering, while playback is occurring on screen
     */ function setPostSeekFixInterval() {
                var _this = this;
                var wasPlaybackRateEverZero = false;
                clearInterval(this.postSeekFixInterval);
                this.postSeekFixInterval = setInterval(function() {
                    var _this_videoElement, _this_videoElement1, _this_videoElement2, _this_videoElement3, _this_videoElement4, _this_videoElement5, _this_videoElement6, _this_videoElement7, _this_videoElement8;
                    _this.logger.verbose("paused: ".concat((_this_videoElement = _this.videoElement) === null || _this_videoElement === void 0 ? void 0 : _this_videoElement.paused, ",                 playbackRate: ").concat((_this_videoElement1 = _this.videoElement) === null || _this_videoElement1 === void 0 ? void 0 : _this_videoElement1.playbackRate, ",                 readyState: ").concat((_this_videoElement2 = _this.videoElement) === null || _this_videoElement2 === void 0 ? void 0 : _this_videoElement2.readyState, ",                 seeking: ").concat((_this_videoElement3 = _this.videoElement) === null || _this_videoElement3 === void 0 ? void 0 : _this_videoElement3.seeking));
                    if (((_this_videoElement4 = _this.videoElement) === null || _this_videoElement4 === void 0 ? void 0 : _this_videoElement4.playbackRate) === 0) {
                        wasPlaybackRateEverZero = true;
                    }
                    if (wasPlaybackRateEverZero && ((_this_videoElement5 = _this.videoElement) === null || _this_videoElement5 === void 0 ? void 0 : _this_videoElement5.seeking) === true && ((_this_videoElement6 = _this.videoElement) === null || _this_videoElement6 === void 0 ? void 0 : _this_videoElement6.paused) === true && ((_this_videoElement7 = _this.videoElement) === null || _this_videoElement7 === void 0 ? void 0 : _this_videoElement7.readyState) < 4 && ((_this_videoElement8 = _this.videoElement) === null || _this_videoElement8 === void 0 ? void 0 : _this_videoElement8.playbackRate) === 1) {
                        // We have encountered a state of the video element that shouldn't exist:
                        // Playback is paused and the the player is still rebuffering (as per `readyState`),
                        // but the playback rate, which should be 0 at this point, is already 1.
                        // On WebOS 3.5, this coincides with a phenomenon that the video is actually
                        // being played back despite it being paused.
                        // Shaka gets confused by this and stops loading content.
                        // We've noticed that calling the below on the element helps it recover.
                        _this.logger.info('Post Seek Fix triggered');
                        clearInterval(_this.postSeekFixInterval);
                        _this.videoElement.play();
                        _this.videoElement.pause();
                    }
                }, POST_SEEK_FIX_INTERVAL);
            }
        }
    ]);
    return ShakaPlayerEngineSeeker;
}();

//# sourceMappingURL=shaka-player-engine-seeker.js.map